module.exports = __webpack_public_path__ + "img/googleDrive.19b5fd89.webp";